import axios from 'axios';
import {
  GET_TEAM_CARD_DATA_REQUEST,
  GET_TEAM_CARD_DATA_SUCCESS,
  GET_TEAM_CARD_DATA_FAILURE,
  GET_TEAM_CARD_DATA_BY_SEASON_REQUEST,
  GET_TEAM_CARD_DATA_BY_SEASON_SUCCESS,
  GET_TEAM_CARD_DATA_BY_SEASON_FAILURE,
  RESET_TEAM_CARD_DATA
} from 'Store/constants';
import { TEAM_CARD_SIDES } from 'Store/constants/sportTypes';
import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

/**
 * BFF takım kartı cevabını TeamCardBroadage ve CardInfo'ın beklediği forma dönüştürür.
 * BFF: { name, teamId, avatarUrl, tournamentId, tournamentName, widgets: [{ name, widgetName }] }
 * Beklenen: { tournament: { name }, widgets: { widgetTabs: [...], teamId, tournamentId } }
 */
function normalizeTeamCardBffPayload (bffData) {
  if (!bffData) return bffData;
  const widgetList = Array.isArray(bffData.widgets)
    ? bffData.widgets
    : (bffData.widgets?.widgets ?? []);
  return {
    ...bffData,
    tournament: bffData.tournament || {
      name: bffData.tournamentName
    },
    widgets: {
      widgetTabs: widgetList,
      teamId: bffData.teamId,
      tournamentId: bffData.tournamentId
    }
  };
}

/**
 * v2 takım kartı için sports-data-bff servisi (getTeamByEventId).
 */
export const getTeamCardDataBff = (eventId, side) => async dispatch => {
  try {
    dispatch({
      type: GET_TEAM_CARD_DATA_REQUEST
    });

    const sideParam = TEAM_CARD_SIDES[side] || 'HOME';
    const res = await axios.get(`${API_GATEWAY}/sports-data/matches/${eventId}/team?side=${sideParam}`);
    const payload = normalizeTeamCardBffPayload(res.data);

    dispatch({
      type: GET_TEAM_CARD_DATA_SUCCESS,
      payload
    });
  } catch (e) {
    dispatch({
      type: GET_TEAM_CARD_DATA_FAILURE,
      payload: errorMessage
    });
  }
};

export const getTeamCardDataBySeason = (teamId, sportType, seasonName) => async dispatch => {
  try {

    dispatch({
      type: GET_TEAM_CARD_DATA_BY_SEASON_REQUEST
    });

    const res = await axios.get(`/mobile/match-card/team/${teamId}/team-card/v2?seasonName=${seasonName}&sportType=FOOTBALL`);

    dispatch({
      type: GET_TEAM_CARD_DATA_BY_SEASON_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_TEAM_CARD_DATA_BY_SEASON_FAILURE,
      payload: errorMessage
    });
  }
};

export const resetTeamCardData = () => async dispatch => {

  dispatch({
    type: RESET_TEAM_CARD_DATA
  });

};
